import { NextRouter } from 'next/router';
import { isString } from 'utils/object';

export function generateRandomInt(max: number): number {
  max = Math.floor(max);
  return Math.floor(Math.random() * (max + 1));
}

export function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}

export function getFilenameFromUrl(url?: string) {
  const validUrl = getValidUrl(url);
  if (validUrl) {
    const pathname = new URL(validUrl).pathname;
    const index = pathname.lastIndexOf('/');
    return -1 !== index ? pathname.substring(index + 1) : pathname;
  }
}

export function getValidUrl(url?: string) {
  if (url && isString(url)) {
    if (url.startsWith('//')) return 'https:' + url;
    if (url.startsWith('www')) return 'https://' + url;
    return url;
  }
}

export function removeUrlParameter(url?: string, paramKey?: string) {
  if (!url || !paramKey) return url;
  const r = new URL(url);
  r.searchParams.delete(paramKey);
  return r.href;
}

export function getSingleValue(value?: unknown, defVal?: unknown) {
  return value !== undefined && value !== null ? (Array.isArray(value) ? value[0] : value) : defVal;
}

export const sameParent = (router?: NextRouter, url?: string) => {
  return router && url && router?.pathname && url.split('/')[1] === router?.pathname?.split('/')[1];
};

export const sameUrl = (router?: NextRouter, url?: string) => {
  return router && url && router?.pathname && (url === router?.pathname || url === router?.asPath);
};

export const parseQueryString = (queryString?: string) => {
  const query = new Map();
  if (queryString) {
    queryString.split('&').forEach(function (part) {
      const item = part.split('=');
      query?.set(item[0], decodeURIComponent(item[1] || ''));
    });
  }
  return Object.fromEntries(query);
};

export const parseEmail = (email: string) => {
  const parts = email.split('<');
  if (parts.length <= 1) {
    return { name: '', email };
  }

  const namePart = parts[0];
  const emailPart = parts[1].split('>')[0];
  return {
    name: namePart ? namePart.trim() : '',
    email: emailPart ? emailPart.trim() : ''
  };
};

export const SIGN_IN = 'signIn';
export const SIGN_UP = 'signUp';
export const FORGOT_PASSWORD = 'forgotPassword';
